import React from "react";
import { Hr } from "@irati/ui/src/Layout";
import Flex from "@irati/ui/src/Flex";
import { Label3 } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import { AtAGlanceCard, FullWidth, AdminStat } from "./styled";
var AtAGlance = function (props) {
    var color = props.color, subdomain = props.subdomain, businessName = props.businessName;
    return (React.createElement(AtAGlanceCard, { small: true },
        React.createElement(Flex, { direction: "column", justifyContent: "center", height: "100%", minWidth: "0" },
            React.createElement(FullWidth, { isHeading: true },
                React.createElement(Label3, { uppercase: true },
                    React.createElement(FormattedMessage, { id: "admin.dashboard.atAGlance.companyDomain" }))),
            React.createElement(FullWidth, null,
                React.createElement(AdminStat, { color: color }, subdomain)),
            React.createElement(Hr, { flush: true }),
            React.createElement(FullWidth, { isHeading: true },
                React.createElement(Label3, { uppercase: true },
                    React.createElement(FormattedMessage, { id: "admin.dashboard.atAGlance.companyName" }))),
            React.createElement(FullWidth, null,
                React.createElement(AdminStat, { color: color }, businessName)))));
};
export default AtAGlance;
